import { render } from "./heroSlider.vue?vue&type=template&id=6be6a085&scoped=true"
import script from "./heroSlider.vue?vue&type=script&lang=js"
export * from "./heroSlider.vue?vue&type=script&lang=js"

import "./heroSlider.vue?vue&type=style&index=0&id=6be6a085&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be6a085"]])

export default __exports__